
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Localtaxihireinpune() {



    const cardData =
    {
        keyword: 'Local Taxi Hire in Pune',
        heading: 'Platinum24 Cabs: Local Taxi Hire in Pune',
        headingDescription: ' Platinum24 Cabs offers convenient Local Taxi Hire in Pune, perfect for daily commutes, shopping trips, office travel, and city sightseeing. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures clean, comfortable, and affordable rides across Pune. With professional chauffeurs, punctual pickups, and transparent pricing, we make local travel smooth and stress-free. Whether you need a quick point-to-point transfer, hourly rental, or a full-day taxi service, Platinum24 Cabs guarantees 24/7 availability, reliable vehicles, and dependable service for all your local taxi needs in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the grand seat of the Peshwas of the Maratha Empire. Its mighty gates, fountains, and sprawling courtyards narrate tales of Bajirao and Mastani. Although partially destroyed by fire in 1828, the ruins still showcase Maratha pride. The evening light-and-sound show recreates historical glory. History lovers and tourists are drawn to its corridors and gardens. Shaniwar Wada is Pune’s proud symbol of heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s belongings and photographs. Its Italian arches and sprawling gardens add elegance. It is also the memorial site of Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of peace and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is remembered for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hilltop fort offers panoramic views of the Sahyadris and trekking trails. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon brings mist and waterfalls, enhancing the experience. Local villagers serve traditional pithla-bhakri at the summit. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, richly decorated with gold, attracts lakhs of devotees. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also renowned for its social and charitable works. The temple’s spiritual aura draws both locals and tourists. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city’s center, it provides peace and spirituality. Evening prayers add a mystical touch. Its ancient rock carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage temple."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure with over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. The recreated Mastani Mahal is a major attraction. Students and history enthusiasts find it highly educational. The museum preserves India’s cultural legacy. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers breathtaking views of the city. The hilltop temple complex is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum enrich its heritage value. Sunsets and sunrises are especially mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned center for spirituality and wellness. Spread across lush gardens, it offers meditation, yoga, and therapy programs. Its Zen gardens and modern lifestyle blend attract seekers worldwide. Visitors experience relaxation, rejuvenation, and inner peace. It is Pune’s global destination for mindfulness. Osho Ashram is the city’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, picnics, and photography here. Seasonal flowers and lush greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot near Pune. It provides water to the city and scenic landscapes for visitors. Monsoon makes it especially beautiful with overflowing streams. Vendors selling hot corn and tea add to the charm. It is also the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


      "services": [
    {
      "name": "Local Taxi Hire Pune",
      "description": "Hire local taxis in Pune for everyday travel needs with our professional and efficient Local Taxi Hire service. Whether you're commuting to work, running errands, or exploring the city, our well-maintained cabs and courteous drivers ensure a smooth and timely ride. With flexible rental options and transparent pricing, we offer unmatched convenience and reliability across Pune."
    },
    {
      "name": "Pune Local Taxi Service",
      "description": "Our Pune Local Taxi Service offers comfortable and affordable rides for intra-city travel. Book hourly or distance-based packages for shopping trips, business meetings, or social outings. With a fleet of hatchbacks, sedans, and SUVs, we cater to all travel needs within Pune city limits, providing prompt pickups and excellent customer support."
    },
    {
      "name": "Affordable Local Taxi Hire Pune",
      "description": "Travel within your budget using our Affordable Local Taxi Hire in Pune. Get low-cost local rides without compromising on safety or quality. Perfect for daily commuters, students, and senior citizens, our pocket-friendly rates and flexible booking options make city travel simple and economical."
    },
    {
      "name": "Pune City Taxi Hire",
      "description": "Navigate the city comfortably with our Pune City Taxi Hire service. Whether it’s visiting friends, attending appointments, or enjoying the nightlife, our taxis are available 24x7 to ensure safe and reliable transport. Choose from AC/non-AC vehicles with trained drivers for a hassle-free city travel experience."
    },
    {
      "name": "Local Cab Booking Pune",
      "description": "Book local cabs in Pune instantly through our user-friendly online or mobile booking system. With real-time availability, instant confirmation, and secure payments, our Local Cab Booking service guarantees a quick and convenient travel solution anytime, anywhere in Pune."
    },
    {
      "name": "Pune Taxi Hire with Driver",
      "description": "Choose Pune Taxi Hire with Driver for stress-free local travel. Our trained, background-verified drivers offer door-to-door pickup and drop services with a professional attitude. Perfect for personal errands, corporate travel, or special events, this service gives you peace of mind and total flexibility."
    },
    {
      "name": "Local Taxi Rates Pune",
      "description": "Explore our transparent and competitive Local Taxi Rates in Pune for hourly or distance-based travel. With no hidden charges and clear breakdowns of fare structures, you can plan your budget and trips more effectively. We also offer special discounts for regular users and senior citizens."
    },
    {
      "name": "Pune Local Taxi Packages",
      "description": "Choose from a wide variety of Pune Local Taxi Packages tailored for sightseeing, shopping, meetings, or leisure rides. Available for half-day, full-day, or hourly usage, our packages provide cost-effective solutions for all types of local travel within the city."
    },
    {
      "name": "Taxi Hire for Events Pune",
      "description": "Planning a wedding, conference, or party in Pune? Use our Taxi Hire for Events service to manage all your guest transportation needs. We provide a fleet of clean, reliable cabs with experienced drivers to ensure timely pickups and drops during events and functions."
    },
    {
      "name": "Pune Local Airport Taxi Hire",
      "description": "Ensure timely airport transfers with our Pune Local Airport Taxi Hire service. Whether arriving or departing, we offer convenient, on-time pickups and drops to Pune Airport with courteous drivers and a variety of vehicle options suitable for solo or group travel."
    },
    {
      "name": "Local Taxi Service Near Me Pune",
      "description": "Looking for a taxi nearby? Our Local Taxi Service Near Me in Pune connects you with the nearest available cab in minutes. With GPS-enabled tracking and citywide coverage, enjoy quick pickups and dependable service from your location, no matter where you are in Pune."
    },
    {
      "name": "Pune Local Taxi Deals",
      "description": "Take advantage of our exciting Pune Local Taxi Deals. Get discounted fares, cashback offers, and seasonal promotions for all your local rides. Ideal for frequent travelers and daily commuters, these deals help you save more while traveling comfortably."
    },
    {
      "name": "Pune Local Cab Service 24x7",
      "description": "Travel around Pune any time of the day or night with our Local Cab Service 24x7. We offer round-the-clock cab availability, reliable service, and responsive customer support to meet your urgent and planned transportation needs efficiently."
    },
    {
      "name": "Local Taxi Booking Online Pune",
      "description": "Book your local taxi in Pune in just a few clicks with our Local Taxi Booking Online platform. View rates, choose your car, and schedule your ride instantly. Our seamless digital experience ensures convenience and peace of mind for every booking."
    },
    {
      "name": "Pune Taxi Hire for Corporate",
      "description": "Our Pune Taxi Hire for Corporate clients provides dependable and professional transportation for business executives and employees. Benefit from monthly billing, chauffeur service, and timely pickups for meetings, conferences, and airport transfers, all while maintaining your brand image."
    }
  ],
  "tableData": [
    ["Local Taxi Hire Pune", "Pune Local Taxi Service"],
    ["Affordable Local Taxi Hire Pune", "Pune City Taxi Hire"],
    ["Local Cab Booking Pune", "Pune Taxi Hire with Driver"],
    ["Local Taxi Rates Pune", "Pune Local Taxi Packages"],
    ["Taxi Hire for Events Pune", "Pune Local Airport Taxi Hire"],
    ["Local Taxi Service Near Me Pune", "Pune Local Taxi Deals"],
    ["Pune Local Cab Service 24x7", "Local Taxi Booking Online Pune"],
    ["Pune Taxi Hire for Corporate", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Reliable Local Taxi Hire in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers dependable and affordable local taxi services across Pune for everyday travel needs."
    },
    {
      "WhyChooseheading": "Quick Pickup and Drop Within City Limits",
      "WhyChoosedescription": "Enjoy fast response times with taxis available near your location for swift city travel."
    },
    {
      "WhyChooseheading": "Clean, AC, and Well-Maintained Vehicles",
      "WhyChoosedescription": "Ride in comfort with sanitized, air-conditioned taxis perfect for Pune’s climate and traffic."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Excellent City Route Knowledge",
      "WhyChoosedescription": "Our drivers ensure timely travel by taking the best routes around Pune’s busy streets."
    },
    {
      "WhyChooseheading": "Flexible Hourly and Point-to-Point Packages",
      "WhyChoosedescription": "Choose from hourly rentals or point-to-point rides based on your local travel requirements."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Know your fare upfront—our pricing includes fuel, driver allowance, and applicable charges."
    },
    {
      "WhyChooseheading": "Ideal for Daily Commute, Shopping, and City Tours",
      "WhyChoosedescription": "Whether it’s work, errands, or sightseeing—our local taxi services cover all needs."
    },
    {
      "WhyChooseheading": "24/7 Booking and Customer Support",
      "WhyChoosedescription": "Book anytime with ease and get support from our round-the-clock customer service team."
    }
  ]




























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide local taxi hire services in Pune?',
        answer: 'Yes, Platinum24 Cabs offers reliable and affordable local taxi hire services across Pune for daily travel, meetings, shopping, or personal use.',
    },
    {
        question: 'How can I hire a local taxi in Pune with Platinum24 Cabs?',
        answer: 'You can easily hire a local taxi through our website, mobile app, or by contacting our customer support for instant bookings.',
    },
    {
        question: 'What types of taxis are available for local hire in Pune?',
        answer: 'We provide a range of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel preferences and budget.',
    },
    {
        question: 'Can I book a local taxi on an hourly basis in Pune?',
        answer: 'Yes, we offer hourly rental packages for local travel in Pune starting from 4 hours/40 km and onwards.',
    },
    {
        question: 'Are your local taxi drivers professional and well-trained?',
        answer: 'Absolutely. All our drivers are licensed, experienced, and familiar with all areas of Pune city.',
    },
    {
        question: 'Is local taxi hire available for multiple stops within the city?',
        answer: 'Yes, you can plan multiple pickups and drop-offs or stops during your local journey within Pune.',
    },
    {
        question: 'Are the taxis sanitized and safe for daily travel?',
        answer: 'All our taxis are regularly cleaned, sanitized, and maintained with strict hygiene protocols.',
    },
    {
        question: 'Can I book a local taxi in Pune for a full day?',
        answer: 'Yes, full-day taxi hire services are available for business, personal errands, or city tours.',
    },
    {
        question: 'What payment methods are accepted for local taxi bookings?',
        answer: 'We accept payments via cash, UPI, digital wallets, and credit/debit cards for your convenience.',
    },
    {
        question: 'Is 24x7 local taxi hire available in Pune?',
        answer: 'Yes, we offer round-the-clock local taxi services to meet your travel needs at any time.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Jagtap',
        feedback: 'I hired a local taxi in Pune with Platinum24 Cabs for a full day. Excellent service and courteous driver!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rutuja Gokhale',
        feedback: 'Very convenient and affordable local taxi hire. The car was clean and the driver was right on time.',
        rating: 5,
    },
];




























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const localTaxiHireSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable Local Taxi Hire service in Pune with experienced drivers, including airport transfers, corporate packages, and event taxi hire.",
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "serviceType": [
    "Local Taxi Hire Pune",
    "Pune Local Taxi Service",
    "Affordable Local Taxi Hire Pune",
    "Pune City Taxi Hire",
    "Local Cab Booking Pune",
    "Pune Taxi Hire with Driver",
    "Local Taxi Rates Pune",
    "Pune Local Taxi Packages",
    "Taxi Hire for Events Pune",
    "Pune Local Airport Taxi Hire",
    "Local Taxi Service Near Me Pune",
    "Pune Local Taxi Deals",
    "Pune Local Cab Service 24x7",
    "Local Taxi Booking Online Pune",
    "Pune Taxi Hire for Corporate"
  ],
  "telephone": "+91-XXXXXXXXXX"
};




    return (
        <div>
<Helmet>
  <title>Local Taxi Hire in Pune | Affordable Taxi Service Pune</title>
  <meta
    name="description"
    content="Affordable and reliable Local Taxi Hire service in Pune with experienced drivers, including airport transfers, corporate packages, and event taxi hire."
  />
  <meta
    name="keywords"
    content="Local Taxi Hire Pune, Pune Local Taxi Service, Affordable Local Taxi Hire Pune, Pune City Taxi Hire, Local Cab Booking Pune, Pune Taxi Hire with Driver, Local Taxi Rates Pune, Pune Local Taxi Packages, Taxi Hire for Events Pune, Pune Local Airport Taxi Hire, Local Taxi Service Near Me Pune, Pune Local Taxi Deals, Pune Local Cab Service 24x7, Local Taxi Booking Online Pune, Pune Taxi Hire for Corporate"
  />
  <script type="application/ld+json">
    {JSON.stringify(localTaxiHireSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/95.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Localtaxihireinpune;